var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinanceLogo = function SvgBinanceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.781 5.883 7.5 3.164l2.72 2.72 1.582-1.582L7.5 0 3.2 4.3zM.5 7l1.582-1.582L3.664 7 2.082 8.582zm4.281 1.117L7.5 10.836l2.72-2.72 1.583 1.58v.002L7.5 14 3.199 9.7l-.002-.003zm6.555-1.116 1.582-1.582L14.5 7l-1.582 1.582z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.9 7 7.503 5.6 6.467 6.634l-.118.119-.245.245L6.102 7l.002.002L7.502 8.4z"
  })));
};
export { SvgBinanceLogo as ReactComponent };